import React, { useState, useEffect } from "react"
import style from "./iframe.mod.scss"
import { graphql } from "gatsby"
import IframeResizer from "iframe-resizer-react"
import { Loading } from "@components"
import { motion } from "framer-motion"

const Iframe = ({ resize = false, isPage = false, ...props }) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(false)
  }, [])

  const variants = {
    hidden: {
      opacity: 0,
      scale: 0,
      tabIndex: -1,
      transition: {
        delay: 0.5,
        opacity: "linear"
      }
    },
    visible: {
      opacity: 1,
      scale: 1,
      tabIndex: 0,
      transition: {
        delay: 0.5,
        opacity: "linear"
      }
    }
  }

  // Remove scrolling from props to prevent it from being passed to either iframe or IframeResizer
  const { scrolling, ...rest } = props

  return (
    <div className={style.iframe}>
      {resize && !isPage ? (
        <div className={style.iframe__inner}>
          <motion.div
            initial={"visible"}
            animate={loading ? "visible" : "hidden"}
            variants={variants}
            className={style.iframe__loading}
          >
            <Loading />
          </motion.div>
          <motion.div
            initial={"hidden"}
            animate={loading ? "hidden" : "visible"}
            variants={variants}
          >
            <IframeResizer
              referrerPolicy="strict-origin-when-cross-origin"
              {...rest}
              scrolling="omit"
              style={
                isPage
                  ? {
                      width: "100%",
                      height: "80vh",
                      overflow: "auto",
                      minHeight: "480px"
                    }
                  : {
                      width: "1px",
                      minWidth: "100%",
                      minHeight: "480px"
                    }
              }
            />
          </motion.div>
        </div>
      ) : (
        <iframe
          referrerPolicy="strict-origin-when-cross-origin"
          {...rest}
          width={isPage ? "100%" : "100%"}
          height={isPage ? "80vh" : "100%"}
          style={
            isPage
              ? {
                  overflow: "auto",
                  overflowX: "hidden",
                  height: "80vh",
                  minHeight: "480px",
                  width: "100%",
                  scrollBehavior: "smooth"
                }
              : {}
          }
        />
      )}
    </div>
  )
}

export default Iframe

export const query = graphql`
  fragment FormIframe on DatoCmsEmbed {
    id
    title
    embed
    isPage
    padding
    model {
      apiKey
    }
    __typename
  }
`
